class Api {
  base = import.meta.env.VITE_PUBLINKER_API_BASE
}

export class SiteApi extends Api {
  siteEntity = 'site'
  site
  constructor(site) {
    super(site)
    this.site = site
  }
  getSiteEndpointUrl = () => `${this.base}/${this.siteEntity}`
  getEndpointUrl = id => {
    const url = `${this.getSiteEndpointUrl()}/${this.site}/${this.entity}`
    if (!id) return url
    return url + `/${id}`
  }
}

export class CompanyApi extends SiteApi {
  entity = 'company'
  getCompanyByIdEndpointUrl = id => {
    const url = `${this.base}/${this.entity}`
    return url + `/${id}`
  }
}

export class DimensionGroupApi extends SiteApi {
  entity = 'dimension-group'
  getCsvEndpointUrl = () => `${this.getEndpointUrl()}/csv`
}

export class UrlTypeApi extends SiteApi {
  entity = 'url-type'
  getImportEndpointUrl = () => `${this.getEndpointUrl()}/import`
}

export class PricingApi extends SiteApi {
  entity = 'pricing'
}

export class PricingOldApi extends SiteApi {
  entity = 'pricing-old'
}

export class PricingImportApi extends SiteApi {
  entity = 'pricing-import'
}

export class PricingRollbackApi extends SiteApi {
  entity = 'pricing-rollback'
}

export class PricingHistoryApi extends SiteApi {
  entity = 'pricing-history'
}

export class LeadsApi extends SiteApi {
  entity = 'leads'
  getLeadsEndpointUrl = () => `${this.base}/site/${this.site}/leads`
  getLeadsDuplicadosEndpointUrl = () =>
    `${this.base}/site/${this.site}/leads-duplicados`
  getQuizzesEndpointUrl = () => `${this.base}/site/${this.site}/quizzes`
}

export class ConfigApi extends SiteApi {
  entity = 'config'
  getPartialEndpointUrl = () => `${this.getEndpointUrl()}/partial`
  getDeployConfigWrapperEndpointUrl = () =>
    `${this.getEndpointUrl()}/deploy-config-wrapper`
}

export class ConfigHistoryApi extends SiteApi {
  entity = 'config-history'
  getConfigHistoryUrl = () => `${this.getEndpointUrl()}`
}

export class ReportApi extends SiteApi {
  entity = 'report'
  getReportWithExchangeEndpointUrl = () =>
    `${this.getEndpointUrl()}-with-exchange`
}

export class RankingEmailApi extends SiteApi {
  entity = 'ranking-email'
}

export class RankingPushApi extends SiteApi {
  entity = 'ranking-push'
}

export class RankingSmsApi extends SiteApi {
  entity = 'ranking-sms'
}

export class RankingWhatsappApi extends SiteApi {
  entity = 'ranking-whatsapp'
}

export class JobApi extends SiteApi {
  entity = 'job'
  getLastJobRunEndpointUrl = (job_name) =>
    `${this.getEndpointUrl()}/${job_name}/last-run`
}

export class CurrencyApi extends Api {
  entity = 'currency'
  getEndpointUrl = () => `${this.base}/${this.entity}`
}

export class OverwatchApi extends Api {
  overwatchEntity = 'overwatch'
  entity = ''
  getOverwatchEndpointUrl = () => `${this.base}/${this.overwatchEntity}`
  getEndpointUrl = () => `${this.getOverwatchEndpointUrl()}/${this.entity}`
}

export class UserApi extends OverwatchApi {
  entity = 'user'
}

export class UserRolesApi extends UserApi {
  entity = 'user'
  getEndpointUrl = user_id =>
    `${this.getOverwatchEndpointUrl()}/${this.entity}/${user_id}/roles`
}

export class OverwatchCompanyApi extends OverwatchApi {
  entity = 'company'
}

export class OverwatchSiteApi extends OverwatchApi {
  entity = 'site'
}

export class OverwatchJobApi extends OverwatchApi {
  entity = 'job'
}

export class AnnotationsApi extends SiteApi {
  entity = 'annotations'
}

export class FetchPermissionsApi extends Api {
  entity = 'fetch-permissions'
  getEndpointUrl = () => {
    const url = `${this.base}/${this.entity}`
    return url
  }
}

export class DashboardApi extends SiteApi {
  entity = 'dashboard'
}

export class PostmasterApi extends SiteApi {
  entity = 'postmaster'
  getEndpointUrl = () =>
    `${this.getSiteEndpointUrl()}/${this.site}/${this.entity}`
  getConfigEndpointUrl = () => `${this.getEndpointUrl()}/config`
}

export class FacebookAdsApi extends SiteApi {
  entity = 'facebook-ads'
  getAccountEndpointUrl = () => `${this.getEndpointUrl()}/account`
  getConfigEndpointUrl = () => `${this.getEndpointUrl()}/config`
}

export class GoogleAdsApi extends SiteApi {
  entity = 'google-ads'
  getAccountEndpointUrl = () => `${this.getEndpointUrl()}/campaigns`
  getConfigEndpointUrl = () => `${this.getEndpointUrl()}/config`
  getCampaignsWithExchangeEndpointUrl = () =>
    `${this.getEndpointUrl()}/campaigns-with-exchange`
}

export class GoogleAdmApi extends SiteApi {
  entity = 'google-adm'
  startGamReport = () => `${this.getEndpointUrl()}/start-gam-report`
  getGamReports = () => `${this.getEndpointUrl()}/gam-reports`
  getGamReportDetail = () => `${this.getEndpointUrl()}/gam-report-detail`
  getAdspeedReportEndpointUrl = () => `${this.getEndpointUrl()}/adspeed`
}

export class ActiveCampaignApi extends SiteApi {
  entity = 'active-campaign'
  getConfigEndpointUrl = () => `${this.getEndpointUrl()}/config`
  getActiveUserEndpointUrl = () => `${this.getEndpointUrl()}/config-user`
  getAccountsEndpointUrl = () => `${this.getEndpointUrl()}/accounts`
  getCampaignsEndpointUrl = () => `${this.getEndpointUrl()}/campaigns`
}

export class QuickFiltersApi extends SiteApi {
  entity = 'quick-filters'
}

export class CheckoutApi extends SiteApi {
  entity = 'checkout'
  getCheckoutEndpointUrl = () => `${this.getEndpointUrl()}/checkout`
}

export class billingApi extends SiteApi {
  entity = 'billing'
}

export class escalatedApi extends SiteApi {
  entity = 'escalated'
}

export class connectionStatusApi extends Api {
  getEndpointUrl = () => `${this.base}/`
}
